export default __webpack_public_path__ + "static/media/default_cover.755e566f.png";